export class DocumentTemplate {
    id: number;
    title: string;
    urlBody: string;
    urlDatasheet: string;
    createdAt: Date;
    lastUpdate: Date;
}